import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import AdyenCheckout from '@adyen/adyen-web';
import '@adyen/adyen-web/dist/adyen.css';
import styles from './styles.scss';

const AdyenForm = ({ sessionData, sessionId, clientKey, environment }) => {
  const adyenContainer = useRef(null);

  useEffect(() => {
    if (!adyenContainer.current) {
      return;
    }

    const config = {
      environment,
      clientKey,
      analytics: {
        enabled: false
      },
      session: {
        id: sessionId,
        sessionData
      }
    };
    const createCheckout = async () => {
      const checkout = await AdyenCheckout({
        ...config,
        onPaymentCompleted: (response, _component) => {
          console.log(response.resultCode);
          console.log(_component);
        },
        onError: (error, _component) => {
          console.error(error);
          console.log(_component);
        }
      });

      if (adyenContainer.current) {
        checkout.create('dropin').mount(adyenContainer.current);
      }
    };

    createCheckout();
  }, []);

  return (
    <div className={styles.checkoutForm}>
      <div ref={adyenContainer} className="payment" />
    </div>
  );
};

AdyenForm.propTypes = {
  sessionData: PropTypes.string.isRequired,
  sessionId: PropTypes.string.isRequired,
  clientKey: PropTypes.string.isRequired,
  environment: PropTypes.string.isRequired
};

export default AdyenForm;
